import api from "../utils/axios";
export async function getUserComments() {
  try {
    const res = await api.get(`/auth/comments`);
    console.log("Comments:",res.data.comments);
    return res.data.comments;
  } catch (error) {
    console.error("Comments fetch error:", error);
    throw error;
  }
}


export async function getProductComments() {
  try {
    const res = await api.get(`/auth/comments`);
    return res.data.comments;
  } catch (error) {
    console.error("Comments fetch error:", error);
    throw error;
  }
}

export async function addComment(comment) {
  const response = await fetch(
    `/auth/comments`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(comment),
    }
  );

  return response.json();
}

export async function deleteComment(id) {
  const response = await fetch(
    `/auth/comments/${id}`,
    {
      method: "DELETE",
    }
  );

  return response.ok;
}